'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  any: { type: 'any' },
  array: { type: 'array' },
  bool: { type: 'bool' },
  element: { type: 'element' },
  func: { type: 'func' },
  node: { type: 'node' },
  number: { type: 'number' },
  object: { type: 'object' },
  string: { type: 'string' },
  symbol: { type: 'symbol' },
  arrayOf: function arrayOf(args) {
    return { type: 'arrayOf', args: args };
  },
  instanceOf: function instanceOf(args) {
    return { type: 'instanceOf', args: args };
  },
  objectOf: function objectOf(args) {
    return { type: 'objectOf', args: args };
  },
  oneOfType: function oneOfType(args) {
    return { type: 'oneOfType', args: args };
  },
  oneOf: function oneOf(args) {
    return { type: 'oneOf', args: args };
  },
  shape: function shape(args) {
    return { type: 'shape', args: args };
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-desc/lib/PropTypes.js
// module id = 588
// module chunks = 0